class StickyAtc {
  constructor() {
    this.container = document.querySelector('.sticky-atc');
    if (!this.container) return;

    this.sectionId = this.container.dataset.section;
    this.button = this.container.querySelector('button');
    if (!this.button) return;

    this.productSection = document.getElementById(`MainProduct-${this.sectionId}`);
    this.submitButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);

    if (!this.productSection || !this.submitButton) return;

    this.setOffsets();
    window.addEventListener('scroll', this.onScroll.bind(this));
    window.addEventListener('resize', this.setOffsets.bind(this));
    this.button.addEventListener('click', () => {
      this.submitButton.click();
    });
  }

  setOffsets() {
    this.productBottom = this.productSection.offsetTop + this.productSection.offsetHeight;
    this.onScroll();
  }

  onScroll() {
    if (window.scrollY > this.productBottom) {
      this.container.classList.add('visible');
    } else {
      this.container.classList.remove('visible');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => new StickyAtc());
